/*
 * @Description:
 * @version:
 * @Author: knight
 * @Date: 2021-10-14 13:52:10
 * @LastEditors: knight
 * @LastEditTime: 2022-02-08 17:58:07
 */
const isProduction = process.env.VUE_APP_STATIC === 'production';
const isTest = process.env.VUE_APP_STATIC === 'testing';

const host_prod = 'https://api.xlhz.com';
const host_test = 'https://apifeature.xlhz.cn';
const host_prod2 = 'https://pc.xlhz.com';
const host_test2 = 'https://feature.xlhz.cn';

const baseUrl = {
  v0: (isProduction ? host_prod : isTest ? host_test : '') + '/api',
  v1: (isProduction ? host_prod : isTest ? host_test : '') + '/api/v1',
};

export const baseUrl2 = {
  v0: isProduction ? host_prod2 : isTest ? host_test2 : '/apv',
  v1: isProduction ? host_prod2 : isTest ? host_test2 : '/apv',
};

export const assetsHost = isProduction ? 'https://pc.xlhz.com' : 'https://feature.xlhz.com';

export const hostUrl = isProduction ? host_prod : host_test;

export const pageUrl = isProduction ? host_prod2 : host_test2;

export default baseUrl;
